const State = (api: any)=>({
    getStates: () =>
        api.get('/state/getStates.php', {},{}),
    createState: (state: {stateName: string})=>
        api.post('/state/addState.php',{}, state),
    updateState: (state: {stateId: number, stateName: string})=>
        api.put('/state/updateState.php',{}, state)
    
});

export default State;